// VaultStats — global vault metrics (public, refreshed every 60s).
import React from "react";
import { Landmark, TrendingUp, Users, Percent } from "lucide-react";
import { useLanguage } from "../../i18n/LanguageContext";
import { tVault } from "../../i18n/vault";

const fmt = (n) => (n != null ? Number(n).toLocaleString() : "—");

export default function VaultStats({ stats }) {
  const { lang } = useLanguage();
  const t = (k) => tVault(lang, k);
  const loading = !stats;

  const cards = [
    { I: Landmark, l: t("tvl"), v: stats ? `${fmt(stats.tvl_rbl)} R₿L` : null, s: stats?.tvl_usd != null ? `≈ $${fmt(stats.tvl_usd)}` : null, id: "vault-tvl" },
    { I: TrendingUp, l: t("monthlyYield"), v: stats ? `${fmt(stats.pool_pending_rbl)} R₿L` : null, s: stats?.pool_usd != null ? `≈ $${fmt(stats.pool_usd)}` : null, id: "vault-monthly-yield" },
    { I: Users, l: t("depositors"), v: stats ? fmt(stats.depositors) : null, s: null, id: "vault-depositors" },
    { I: Percent, l: t("estimatedAPY"), v: stats ? (stats.estimated_apy != null ? `~${stats.estimated_apy}%` : "—") : null, s: t("estimated"), id: "vault-apy" },
  ];

  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4" data-testid="vault-stats">
      {cards.map(({ I, l, v, s, id }) => (
        <div key={id} data-testid={id}
          className={`rounded-2xl border border-white/10 bg-white/[0.02] p-4 backdrop-blur ${loading ? "animate-pulse" : ""}`}>
          <p className="flex items-center gap-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-white/40">
            <I className="h-3.5 w-3.5 text-amber-300" /> {l}
          </p>
          <p className="mt-2 font-mono text-xl font-black text-white md:text-2xl">
            {loading ? <span className="inline-block h-6 w-20 rounded bg-white/10" /> : v}
          </p>
          {!loading && s && <p className="mt-0.5 text-[10px] font-mono text-white/35">{s}</p>}
        </div>
      ))}
    </div>
  );
}
